import { useMutation } from "@tanstack/react-query";

import { authApi } from "@shared/api";

type OTPParams = {
  id: string;
  code: string;
  email: string;
};

export const useSignInVerifyOTP = () => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (payload: OTPParams) =>
      authApi.postApiV1AuthSignInVerify(
        {
          requestSource: "WEB",
          verifySignInRequest: {
            email: payload.email,
            otp: { otpCode: payload.code, otpId: payload.id },
          },
        },
        { withCredentials: true },
      ),
  });

  return { error, signInVerify: mutateAsync, isPending };
};
